import styled from 'styled-components'
import { Text } from 'common-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const Title = styled(Text)`
  height: 20px;
  margin-bottom: 6px;

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    margin-bottom: 0;
  }
`
